/*
 * TestTypes Messages
 *
 * This contains all the text for the TestTypes container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.TestTypes';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Test Groups',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Total',
  },
  addTestType: {
    id: `${scope}.addTestType`,
    defaultMessage: 'Add Test Group',
  },
  editTestType: {
    id: `${scope}.editTestType`,
    defaultMessage: 'Update Test Group',
  },
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  id: {
    id: `${scope}.id`,
    defaultMessage: 'Id',
  },
  deleteGroup: {
    id: `${scope}.deleteGroup`,
    defaultMessage:
      'Are you sure you want to delete this Test Group? All tests belonging to this group become unavailable.',
  },
});
